<template>
    <div class="setting">
        <div
            class="setting-main card"
            v-loading="infoForm.loading.form || passwordForm.loading.form"
        >
            <div class="setting-aside">
                <el-avatar shape="square" :size="120" :src="infoForm.data.avatar"></el-avatar>
                <template v-if="tab == 1">
                    <el-link type="primary" :underline="false" @click="GetAvatar">更换头像</el-link>
                </template>
            </div>
            <div class="setting-container">
                <el-tabs v-model="tab">
                    <el-tab-pane label="基本信息" name="1">
                        <el-form
                            ref="infoForm"
                            :model="infoForm"
                            label-position="left"
                            label-width="120px"
                            size="small"
                        >
                            <el-form-item label="姓名：" prop="row.user_name">
                                <el-input
                                    v-model="infoForm.data.user_name"
                                    placeholder="真实姓名"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="性别：">
                                <el-select v-model="infoForm.data.sex">
                                    <el-option :key="1" label="男" :value="1"></el-option>
                                    <el-option :key="2" label="女" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="手机号：" prop="phone">
                                <el-input
                                    v-model="infoForm.data.phone"
                                    placeholder="手机号"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱：">
                                <el-input
                                    v-model="infoForm.data.email"
                                    placeholder="邮箱"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    size="small"
                                    :loading="infoForm.loading.submit"
                                    @click="SubmitInfo('infoForm')"
                                    >保 存</el-button
                                >
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="修改密码" name="2">
                        <el-form
                            ref="passwordForm"
                            :model="passwordForm"
                            label-position="left"
                            label-width="120px"
                            size="small"
                            status-icon
                        >
                            <el-form-item label="原密码：" prop="old_password">
                                <el-input
                                    type="password"
                                    v-model="passwordForm.data.old_password"
                                    placeholder="原密码"
                                    autocomplete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="新密码：" prop="new_password">
                                <el-input
                                    type="password"
                                    v-model="passwordForm.data.new_password"
                                    placeholder="新密码"
                                    autocomplete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码：" prop="new_password_confirmation">
                                <el-input
                                    type="password"
                                    v-model="passwordForm.data.new_password_confirmation"
                                    placeholder="确认密码"
                                    autocomplete="off"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    size="small"
                                    :loading="passwordForm.loading.submit"
                                    @click="SubmitPassWord('passwordForm')"
                                    >保 存</el-button
                                >
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {
            tab: '1',
            infoForm: {
                loading: {
                    form: false,
                    submit: false
                },
                data: {
                    id: null,
                    avatar: null,
                    user_name: null,
                    sex: null,
                    phone: null,
                    email: null
                }
            },
            passwordForm: {
                loading: {
                    form: false,
                    submit: false
                },
                data: {
                    old_password: null,
                    new_password: null,
                    new_password_confirmation: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetInfo()
        })
    },
    methods: {
        // 更换头像
        GetAvatar() {
            let random = Math.floor(Math.random() * 24 + 1)
            this.infoForm.data.avatar = require('@/assets/avatar/' + random + '.png')
        },
        // 我的信息
        GetInfo() {
            this.infoForm.loading.form = true
            this.$request({
                url: '/api/v1/users/info'
            }).then(res => {
                if (!res.status) {
                    this.infoForm.loading.form = false
                    this.infoForm.data = {
                        id: res.data.id,
                        avatar: res.data.avatar,
                        user_name: res.data.name,
                        sex: res.data.sex,
                        phone: res.data.phone,
                        email: res.data.email,
                        identity: res.data.identity_id
                    }
                    this.$store.commit('setEnterprise', {
                        id: res.data.enterprise.id,
                        domain: res.data.enterprise.domain,
                        name: res.data.enterprise.name,
                        invite: res.data.enterprise.invite_code
                    })
                    this.$store.commit('setUser', {
                        id: res.data.id,
                        avatar: res.data.avatar,
                        name: res.data.name,
                        phone: res.data.phone,
                        email: res.data.email,
                        identity: res.data.identity_id
                    })
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        SubmitInfo(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.infoForm.loading.submit = true
                    this.$request({
                        url: '/api/v1/users_add',
                        data: this.infoForm.data
                    }).then(res => {
                        this.infoForm.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.GetInfo()
                            this.reload()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        SubmitPassWord(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.passwordForm.loading.submit = true
                    this.$request({
                        url: '/api/v1/change_password',
                        params: {
                            ...this.passwordForm.data
                        }
                    }).then(res => {
                        this.passwordForm.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.$store.commit('setToken')
                            this.reload()
                        }
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
.setting {
    &-main {
        display: flex;
        padding: 20px 60px;
    }
    &-aside {
        padding: 54px 60px 0 0;
        .el-link {
            display: flex;
            padding: 10px 0;
            justify-content: center;
        }
    }
    &-container {
        flex: 1;
    }
}
.el-form {
    padding-top: 18px;
}
</style>
